import React from 'react';
import { AlertCircle } from 'lucide-react';

const DISCLAIMER_TEXT = 'Not investment advice. We aggregate social sentiment only. Do your own research and consult financial advisors before investing.';

interface SentimentDisclaimerProps {
  /** default = card with icon; compact = one line for footer */
  variant?: 'default' | 'compact';
  className?: string;
}

const SentimentDisclaimer: React.FC<SentimentDisclaimerProps> = ({ variant = 'default', className = '' }) => {
  if (variant === 'compact') {
    return (
      <p className={`text-[10px] text-white/20 uppercase tracking-widest leading-snug max-w-2xl mx-auto ${className}`.trim()}>
        {DISCLAIMER_TEXT}
      </p>
    );
  }

  return (
    <div className={`card-glass sentiment-disclaimer-card px-4 py-3 ${className}`.trim()}>
      <div className="flex items-start gap-3">
        <AlertCircle className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" aria-hidden />
        <p className="text-xs text-[#bbb] leading-relaxed">
          <strong className="text-[#ccc]">Not investment advice.</strong> We aggregate social sentiment only. Do your own research and consult financial advisors before investing.
        </p>
      </div>
    </div>
  );
};

export default SentimentDisclaimer;
